var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-header',[_c('div',{staticClass:"header-col header-brand"},[_c('h6',[_vm._v("PT Help")])])])}
var staticRenderFns = []

export { render, staticRenderFns }